export const MAX_SUPPLY_DISTANCE = 5;
export const FARM_SUPPLY_STANDARD_COUNT = 1;
export const FARM_SUPPLY_WITH_WAREHOUSE_COUNT = 2;
export const FARM_SUPPLY_BLOCKED_COUNT = -1;
export const MAX_UNIT_SUPPLY = 2; // базовое снабжение + дополнительное снабжение